import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { assetSizesBigToSmall, specialCaseFormats } from '../../../consts';
import { AppConfigService } from '../../../providers/config.service';

@Component({
  selector: 'app-gallery-picture',
  standalone: true,
  imports: [],
  templateUrl: './gallery-picture.component.html',
  styleUrl: './gallery-picture.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryPictureComponent implements OnChanges {
  private config = inject(AppConfigService);
  @Input({ required: true }) uuid: string;
  @Input({ required: true }) sourceWidth: number;
  @Input({ required: true }) sourceHeight: number;
  @Input({ required: true }) extension: string;
  @Input() position: string;
  @Input() maxWidth = Infinity;
  @Input() loading: 'lazy' | 'eager' = 'lazy';
  @Input() cover: boolean;

  urlData: {
    sources: {
      media: string;
      srcset: string;
    }[];
    src: string;
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uuid) {
      this.urlData = this.getUrlData();
    }
  }

  private getUrlData() {
    const canUseSpecialVersion = specialCaseFormats.includes(this.extension);
    const newExtension = canUseSpecialVersion ? 'webp' : 'jpg';

    const maxWidth = Math.min(this.maxWidth, this.sourceWidth);
    const sizes = assetSizesBigToSmall.filter((size, i) => {
      const nextSize = assetSizesBigToSmall[i - 1];
      if (!nextSize) return false;
      if (nextSize > maxWidth && i !== assetSizesBigToSmall.length - 1) return false;
      return true;
    });

    const srcSetDatas = sizes
      .map((size, i) => {
        const biggerSize = sizes.length === 1 ? size : sizes[i - 1];
        if (!biggerSize) return;

        const useBase = i === sizes.length - 1 && this.sourceWidth <= biggerSize;
        if (useBase) {
          return {
            srcSet: `${this.config.assetsEndpoint}/images/${this.uuid}/base/${this.uuid}.${newExtension}`,
            size,
          };
        }
        return {
          srcSet: `${this.config.assetsEndpoint}/images/resized/${biggerSize}x/${this.uuid}.${newExtension}, ${
            this.config.assetsEndpoint
          }/images/resized/${biggerSize * 2}x/${this.uuid}.${newExtension} 2x`,
          size,
        };
      })
      .filter(Boolean);

    return {
      sources: srcSetDatas.map(({ size, srcSet }, i) => ({
        media: i === srcSetDatas.length - 1 ? `(min-width: 0px)` : `(min-width: ${size}px)`,
        srcset: srcSet,
      })),
      src: srcSetDatas[0].srcSet.split(', ')[0],
    };
  }
}
